import { rem } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Chess } from "chess.js";
import { useContextMenu } from "mantine-contextmenu";
import React from "react";

interface Props {
    game: Chess;
    children: React.ReactNode;
    className?: string;
}

export const copyPgn = async (game: Chess) => {
    try {
        await navigator.clipboard.writeText(game.pgn());
        notifications.show({
            title: "PGN copied",
            message: "",
            icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
            color: "green",
        });
    } catch (error) {
        notifications.show({
            title: "Failed to copy",
            message: "",
            icon: (
                <IconX
                    style={{
                        width: rem(18),
                        height: rem(18),
                    }}
                />
            ),
            color: "red",
        });
    }
};

const ContextMenu: React.FC<Props> = ({ game, children, className }) => {
    const { showContextMenu } = useContextMenu();
    return (
        <div
            className={className}
            onContextMenu={showContextMenu([
                {
                    key: "copyFEN",
                    title: "Copy FEN",
                    onClick: async () => {
                        try {
                            await navigator.clipboard.writeText(game.fen());
                            notifications.show({
                                title: "FEN copied",
                                message: "",
                                icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
                                color: "green",
                            });
                        } catch (error) {
                            notifications.show({
                                title: "Failed to copy",
                                message: "",
                                icon: (
                                    <IconX
                                        style={{
                                            width: rem(18),
                                            height: rem(18),
                                        }}
                                    />
                                ),
                                color: "red",
                            });
                        }
                    },
                },
                {
                    key: "copyPGN",
                    title: "Copy PGN",
                    onClick: async () => await copyPgn(game),
                },
            ])}
        >
            {children}
        </div>
    );
};

export default ContextMenu;
